import {Logic} from './Type'
// import * as Assets from '../../src/Assets/Assets'
export class Login extends Logic.Type {
/*
    IframeBackground: string
    token: string
 */
    Username: string = ''
    Password: string = ''
    Mail: string = ''
    Name: string = ''
    Verified: boolean = false    
/*
    Nat: string
    DateOfBirth: string
    ViewLarge:boolean = false

    AccountJustCreated: number = 0
    // this is just intially to create an user
    UsernameNew: string = ''
    PasswordNew: string = ''
    PlayerExists: boolean = false
    Balance: string
    SocialBalance: string
    IceBalance: string
    BalanceAdd : number = 5
    XpAdd: number = 100
    PasswordIncorrect:boolean = false
    UsernameEmpty:boolean = false
    Currency: string = Assets.DefaultCurrency
    Mode: boolean = false
    GameMode = false
    IframeLink: string
*/    
}


// WEBPACK FOOTER //
// ./src/Logic/Login.ts